
























import {Component, Prop, Vue} from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { Mutation } from 'vuex-module-decorators';
import TransactionItem from '@/components/User/Wallet/TransactionItem.vue';

@Component({
    components: {
        TransactionItem,
    },
})

export default class Transactions extends Vue {

    @Prop() public transactions: any;

    constructor() {
        super();
    }

}
